/*
 * Project: bellcloud_fe
 * File: src/components/layout/DefaultLayout.tsx
 * Author: SWAN
 * Created: 2025-07-04
 * Description: Default layout with Sidebar and Topbar
 */

import React from 'react';
import styled from '@emotion/styled';
import { SideBar } from './web/SideBar';
import { TopBar } from './web/TopBar';
import { Outlet } from 'react-router-dom';
import { usePolicyStore } from '@/policy/policyStore';

/**
 * Layout Structure:
 *
 * LayoutContainer (height: 100vh, flex-row)
 * ├─ SideBar (고정 너비)
 * └─ ContentArea (flex: 1, flex-column, min-height: 0)
 *    ├─ TopBarArea (flex-shrink: 0) - TopBar 높이 고정
 *    │  └─ TopBar
 *    └─ MainArea (flex: 1, min-height: 0) - 나머지 공간 차지
 *       └─ Outlet
 *          └─ DefaultContents (padding, overflow 관리)
 */
const LayoutContainer = styled.div`
  display: flex;
  flex-direction: row;
  height: 100%;
  width: 100%;
  max-width: 100%;
  overflow-x: hidden;
  background-color: ${({ theme }) => theme.colors.surface.layout.background};
`;

const ContentArea = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
`;

const TopBarArea = styled.div`
  flex-shrink: 0;
`;

const MainArea = styled.div`
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

export const DefaultLayout: React.FC = () => {
  const { menuTree } = usePolicyStore();

  return (
    <LayoutContainer>
      <SideBar menuData={menuTree} />
      <ContentArea>
        <TopBarArea>
          <TopBar />
        </TopBarArea>
        <MainArea>
          <Outlet />
        </MainArea>
      </ContentArea>
    </LayoutContainer>
  );
};
